<template>
  <div class="observa4-header-print">
      <div class="sheet-title">
        <h2>{{ mainTitle }}</h2>
        <h3>{{ subTitle }}</h3>
      </div>
      <div class="compliance-ladder">
          <span class="filter-label"
                v-for="(c, k) in complianceLadder"
                :key="`filter-${k}`">
            <span class="label" :class="`label-${k}`">
              {{ sc.priority[k] }}
            </span>
          </span>
      </div>
      <div>
        <span class="glyphicon glyphicon-exclamation-sign summary-warning text-warning">
        </span>
        * Un effectif faible correspond à moins de 30 observations.
      </div>
      <div class="counters">
          <span class="filter-label"
                v-for="(c, k) in counters"
                :key="`counter-${k}`">
            <span class="label" :class="`label-${c.style}`">
              {{ c.title }} : {{ c.value }} fiche.s
            </span>
          </span>
      </div>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'
import modules from '@/sui/data/modules'
import sc from '@/sui/components/results/sc/observa4'

export default {
  name: 'o4-header-print',

  props: {
    year: {
      type: Number,
      required: true
    },

    counts: {
      type: Object,
      required: true
    },

    viewType: {
      type: String,
      required: true
    },

    subTitle: {
      type: String,
      required: true
    },

    complianceLadder: {
      type: Object,
      required: true
    }

  },

  data: function () {
    return {
      sc: sc
    }
  },

  computed: {
    mainTitle: function () {
      return sc.highlightTitles(this.viewType)
    },

    counters: function () {
      const y = this.year
      if (y == null) {
        return []
      }

      const formatter = modules.get(y).observa4.format.obsManagment
      const result = []
      for (let key in this.counts.values) {
        const name = formatter(parseInt(key))
        assert.notNull(name)
        result.push(
          {
            title: name,
            style: name.toLowerCase(),
            value: this.counts.values[key]
          }
        )
      }
      return result
    }
  }

}

</script>
<style scoped lang="less">
.observa4-header-print {
  text-align: center;

  .sheet-title {
    font-weight: bold;
    color: black;
  }

  .compliance-ladder, .counters {
    display: flex;
    justify-content: center;
    gap: 0.1cm;
    font-size: 110%;
  }

  .counters {
    margin-bottom: 0.25cm;
  }

  .summary-warning {
    margin-right: 0.2rem;
  }
}

</style>
